import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as removeAccents from 'remove-accents';
import { CartaoPeriodoPadrao } from 'src/app/models/cartao-periodo-padrao';
import { ContractAssignor, UpdateContractAssignor } from 'src/app/models/contract-assignor';
import { ProdutoCategoria } from 'src/app/models/produto-categoria';
import { CartaoService } from 'src/app/services/cartao.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { Auth } from '../../../../../models/auth';
import { CedenteContrato } from '../../../../../models/cedente-contrato';
import { TermoUso } from '../../../../../models/termo-uso';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { ContratoService } from '../../../../../services/contrato.service';
import { TermoUsoService } from '../../../../../services/termo-uso.service';
import { ApiError } from '../../../../../shared/enums/api-error.enum';

@Component({
    selector: 'app-contratos-list',
    templateUrl: './contratos-list.component.html',
    styleUrls: ['./contratos-list.component.css']
})
export class ContratosListComponent implements OnInit {


    @ViewChild('drawer') drawer: MatSidenav;
    public updateContratoForm: FormGroup;

    private currentUser: Auth;
    private cedenteContrato: CedenteContrato[];
    public cedenteContratoList: CedenteContrato[];
    public termoUso: TermoUso;
    public categoriaProduto = CategoriaProduto;
    public cartaoPeriodosPadroes: DropDownItem[] = [];
    public cedenteContratoToUpdate: CedenteContrato;
    public contractAssignorToUpdate: ContractAssignor;
    public produtoCategoria: ProdutoCategoria[];
    public periodoPadraoCartao: CartaoPeriodoPadrao;
    hasStandardPeriod: boolean = false;
    public produtoPeriodoPadrao: string;
    private parametros: { [key: string]: string };

    public contractAssignor: ContractAssignor[];
    public contractAssignorList: ContractAssignor[];

    public DataAdesao: string;
    private idProdutoElegivel: number;
    filtroPesquisa: string;
    modalReference: any;
    public category: any = 1;

    //#region Paginação
    currentPage = 1;
    showItem = '25';
    //#endregion

    //#region Booleans
    isEmpty = false;
    public checked = true;
    continue = false;
    permitirValorIncremento = false;
    //#endregion


    //#region ErrosMessages
    public messageValorPadrao: string;
    public messageValorMaximo: string;
    public messageValorIncremento: string;
    public messageTermo: string;
    public messageErro: string;
    public inValorPadraoInvalid: boolean = false;
    public inValorMaximoInvalid: boolean = false;
    public inValorIncrementoInvalid: boolean = false;
    public inTermoInvalid: boolean = false;
    //#endregion

    constructor(
        private authenticationService: AuthenticationService,
        private contratoService: ContratoService,
        private alertService: NewAlertService,
        private termoUsoService: TermoUsoService,
        private parametrosDataService: ParametrosDataService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private cartaoService: CartaoService,
        private formBuilder: FormBuilder) {
        this.DataAdesao = '01/01/2020';
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.produtoCategoria = JSON.parse(localStorage.getItem('productCategory'));
        this.produtoCategoria = this.produtoCategoria.filter(el => el.canList && el.id != CategoriaProduto.Flex);
        this.produtoCategoria.sort((a, b) => (a.categoryListOrder > b.categoryListOrder) ? 1 : -1);
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros[ParametrosKey.permitirValorIncremento]) {
            this.permitirValorIncremento = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirValorIncremento]
            );
        } else {
            this.permitirValorIncremento = false;
        }
        this.createForm(new ContractAssignor(0,0,'',null,null,null));
        this.load();
    }

    createForm(cedenteContrato: ContractAssignor) {
        this.updateContratoForm = this.formBuilder.group({
            valorPadrao: new FormControl(cedenteContrato.standardValue, [
                Validators.required,
                Validators.min(0)
            ]),
            valorMaximoBeneficio: new FormControl(cedenteContrato.maximumValue),
            valorIncremento: new FormControl(cedenteContrato.incrementValue),
            ehEditavel: new FormControl(cedenteContrato.isEditable, [
                Validators.required
            ]),
            priorizado: new FormControl(cedenteContrato.inPriority, [
                //Validators.required
            ]),
            cartaoPeriodoPadraoId: new FormControl(cedenteContrato.standardPeriodId, [
                Validators.required
            ])
        });
    }


    private load() {
        this.cartaoService.getAllCartaoPeriodoPadrao().subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    response.result.forEach(obj => {
                        this.cartaoPeriodosPadroes.push(new DropDownItem(obj.valor.toString(), obj.descricao));
                    });
                }
            }, error => { console.log(error); }
        );

        this.contratoService.getContracts(this.currentUser.token.assignorGuid,this.categoriaProduto.Tradicional).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.isEmpty = false;
                    this.checked = true;
                    this.contractAssignor = response.result;
                    this.contractAssignorList = response.result;

                    if (this.contractAssignorList.length <= 0 && this.contractAssignor.length <= 0) {
                        this.isEmpty = true;
                        this.messageErro = response.message;
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar os contratos do cedente' + error);
            }
        );
    }

    changeCategory(e,vcategory: number = 0) {

        if(this.drawer.opened)
            this.drawer.toggle();

        if(e != null && vcategory == 0){
            this.category = e.target.value;
        }
        if(vcategory != 0)
            this.category = vcategory;

        this.contratoService.getContracts(this.currentUser.token.assignorGuid,this.category).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.isEmpty = false;
                    this.contractAssignor = response.result;
                    this.contractAssignorList = response.result;

                    if (this.contractAssignorList.length <= 0 && this.contractAssignor.length <= 0) {
                        this.isEmpty = true;
                        this.messageErro = response.message;
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar contrato do cedente' + error);
            }
        );
    }


    showTermo(content, produtoGuid: string, produtoElegibilidadeId: number) {
        this.termoUsoService.getTermoUso(produtoGuid).subscribe(
            response => {
                this.termoUso = response.result;
                this.idProdutoElegivel = produtoElegibilidadeId;
                this.modalService.open(content, { centered: true, size: 'lg' });
            },
            error => {
                this.alertService.error('Erro ao carregar termo de uso do produto! Por favor tente novamente mais tarde.');
            }
        );
    }

    searchFilter() {
        if (!this.filtroPesquisa) {
            return this.contractAssignorList = this.contractAssignor;
        } else {
            this.contractAssignorList = this.contractAssignor;
            this.contractAssignorList = this.contractAssignorList.filter(
                s => removeAccents(s.productEligibility.product.descricaoProduto).toLocaleLowerCase().includes(removeAccents(this.filtroPesquisa).toLocaleLowerCase())
            );
        }
    }

    newContrato() {
        this.router.navigate(['portal/novobeneficio/contratar']);
    }

    onSubmit(cedenteContrato: CedenteContrato) {

        if(this.updateContratoForm.valid){

            if (cedenteContrato.valorMaximoBeneficio > 0 && cedenteContrato.valorMaximoBeneficio < cedenteContrato.valorPadrao/* || valorMaximoBaneficio <= 0 || isNaN(valorMaximoBaneficio)*/){
                this.inValorMaximoInvalid = true;
                this.messageValorMaximo = 'O valor máximo deve ser maior ou igual ao valor padrão do produto!';
            }
            else
                this.inValorMaximoInvalid = false;

            /*
            if(valorIncremento <= 0 || isNaN(valorIncremento)){
                this.inValorIncrementoInvalid = true;
                this.messageValorIncremento = 'O valor de incremento deve ser maior que zero!';
            }
            else
                this.inValorIncrementoInvalid = false;
            */

            /*
            if(cedenteContrato.valorMaximoBeneficio < cedenteContrato.valorPadrao || cedenteContrato.valorMaximoBeneficio <= 0){
                cedenteContrato.valorMaximoBeneficio = cedenteContrato.valorPadrao;
            }

            if(cedenteContrato.valorIncremento <= 0 || cedenteContrato.valorIncremento == null){
                cedenteContrato.valorIncremento = 1;
            }

            if(!cedenteContrato.ehEditavel){
                cedenteContrato.valorMaximoBeneficio = cedenteContrato.valorPadrao;
                cedenteContrato.valorIncremento = 1
            }*/
            if(!this.inValorMaximoInvalid){
                const updateContractAssignor = new UpdateContractAssignor(cedenteContrato.valorPadrao, +cedenteContrato.cartaoPeriodoPadraoId, cedenteContrato.ehEditavel, cedenteContrato.valorMaximoBeneficio, cedenteContrato.valorIncremento, cedenteContrato.priorizado);
                this.contratoService.updateContract(this.contractAssignorToUpdate.id, this.currentUser.token.assignorGuid, updateContractAssignor).subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.changeCategory(null, this.category);
                            this.alertService.success(response.message);
                        } else {
                            this.alertService.error(response.message);
                        }
                    }, error => { console.log(error); }
                );
            }
        }
    }

    showConfigValores( cedenteContrato: ContractAssignor) {
        if(cedenteContrato.productEligibility.product.categoriaProduto == 2 || cedenteContrato.productEligibility.product.categoriaProduto == 7)
            return;
        this.contractAssignorToUpdate = cedenteContrato;
        this.updateContratoForm.controls.valorPadrao.setValue(this.contractAssignorToUpdate.standardValue);
        this.updateContratoForm.controls.valorMaximoBeneficio.setValue(this.contractAssignorToUpdate.maximumValue);
        this.updateContratoForm.controls.valorIncremento.setValue(this.contractAssignorToUpdate.incrementValue );
        this.updateContratoForm.controls.ehEditavel.setValue(this.contractAssignorToUpdate.isEditable);
        this.updateContratoForm.controls.priorizado.setValue(this.contractAssignorToUpdate.inPriority);
        if(this.contractAssignorToUpdate.standardPeriodId === null){
            this.hasStandardPeriod = false;
            this.updateContratoForm.controls.cartaoPeriodoPadraoId.setValue(this.contractAssignorToUpdate.standardPeriodId);
        }
        else{
            this.hasStandardPeriod = true;
            this.produtoPeriodoPadrao = this.cartaoPeriodosPadroes.find(x=>x.ITEM_ID === this.contractAssignorToUpdate.standardPeriodId.toString()).ITEM_TEXT;
            this.updateContratoForm.controls.cartaoPeriodoPadraoId.setValue(this.contractAssignorToUpdate.standardPeriodId);
        }

        if(!this.drawer.opened)
            this.drawer.toggle();
        }

    showModalValores(content: any, cedenteContrato:  ContractAssignor) {
        if(cedenteContrato.productEligibility.product.categoriaProduto == 2)
            return;
        this.contractAssignorToUpdate = cedenteContrato;
        this.modalReference = this.modalService.open(content, { centered: true, size: 'lg', windowClass: 'modal-md'});
    }

    cancelContrato(produtoElegibilidadeId: number) {
        this.contratoService.cancelContract(this.currentUser.token.assignorGuid, produtoElegibilidadeId).subscribe(
            response => {
                if (ApiError.Sucesso === response.status) {
                    this.alertService.success(response.message);
                    this.load();
                } else {
                    this.alertService.error('Erro ao cancelar adesão do produto! Por favor tente novamente mais tarde.');
                }
            },
            error => {
                this.alertService.error('Erro ao cancelar adesão do produto! Por favor tente novamente mais tarde.');
            }
        );
    }

    close() {
        this.drawer.toggle();
    }

    public get form() {
        return this.updateContratoForm.controls;
    }

    ehEditavelCheck(event,content){
        let isChecked = event.target.checked;
        if(!isChecked && !this.contractAssignorToUpdate.isEditable === isChecked){
            this.modalReference = this.modalService.open(content, { centered: true, size: 'lg'});
        }
    }

    onConfirm(){
        this.modalReference.close();
    }

    onCancel(){
        this.updateContratoForm.controls.ehEditavel.setValue(true)
        this.modalReference.close();
    }
}
